export const handleAnalaytics = (wrapperEl, index) =>
{
    wrapperEl.addEventListener('click', function handleClick(e) {
        const buyButtonClick = e.target.classList.contains('buy-button');
        let req = '';
        let price = ''
        const ul = this.closest('.product-list');
        const searchResult = document.getElementById('search-result');
        const priceProp = this.querySelector('#priceprop');
        if (priceProp) {
            price = priceProp.getAttribute('content');
        }
        if (ul.dataset.klevurec) {
            req = '/api/klevu/recnav?' +
                "t=" + ul.dataset.klevutag +
                "&r=" + ul.dataset.klevurec +
                "&i=" + index +
                "&v=" + this.dataset.klevu +
                "&p=" + price;

            if (buyButtonClick) {
                fetch(req, {
                    method: 'GET',
                    headers: {
                        'pragma': 'no-cache',
                        'cache-control': 'no-cache',
                        'litium-request-context': JSON.stringify(
                            window.__litium.requestContext
                        )
                    }
                });
            }
        } else if (window.__litium.requestContext.productCategorySystemId) {
            req = '/api/klevu/catnav?cat=' + window.__litium.requestContext.productCategorySystemId + "&v=" + this.dataset.klevu;
        } else if (window.__litium.constants.productListSystemId) {
            req = '/api/klevu/listnav?list=' + window.__litium.constants.productListSystemId + "&v=" + this.dataset.klevu;
        } else if (searchResult) {
            req = '/api/klevu/quicksearch?v=' + this.dataset.klevu + "&q=" + encodeURIComponent(document.querySelector('.query').innerHTML);
        }
        if (!buyButtonClick) {
            sessionStorage.setItem('klevu', req);
        }
    });
}